module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.view == 'index') ? [(_vm.loading.history) ? _c('spinner') : _c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.messages,
      "pagination-options": {
        'enabled': true
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'status') ? _c('span', [_c('span', {
          staticClass: "label label-sm",
          class: [props.row.status == 3 ? 'label-danger' : 'label-warning']
        }, [_vm._v(" " + _vm._s(_vm.statuses[props.row.status]) + " ")])]) : (props.column.field == 'actions') ? [_c('button', {
          staticClass: "btn btn-xs green",
          on: {
            "click": function($event) {
              return _vm.viewEmail(props.row.id)
            }
          }
        }, [_vm._v("View")])] : (props.column.field == 'sent_at.date') ? _c('span', [(props.row.sent_at) ? [_vm._v(_vm._s(_vm._f("formatDate")(props.row.sent_at.date)))] : _vm._e()], 2) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, false, 2610876121)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    No emails available.\n                ")])])], 1)] : (_vm.view == 'viewEmail') ? [_c('edit-email', {
    on: {
      "back": _vm.switchToIndex
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f6a67f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/EmailHistoryIndex.vue
// module id = 1614
// module chunks = 1